import { queryOptions, skipToken } from '@tanstack/react-query'
import { keys } from './keys'
import { fetchStore, fetchStores } from './stores.queries'

export const getStoresOptions = () =>
  queryOptions({
    queryKey: keys.stores.list(),
    queryFn: fetchStores,
  })

export const getBoutiquesOptions = () =>
  queryOptions({
    ...getStoresOptions(),
    select: (data) =>
      data.filter((store) => store.storeType === 'BOUTIQUE' || store.storeType === 'REMOTE'),
  })

export const getStoreOptions = (id: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.byId(id),
    queryFn: id !== undefined ? () => fetchStore(id) : skipToken,
  })
